















import Vue from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Helpers from './helpers';

export default Vue.extend({
  name: 'App',
  components: {
    Header, Footer
  }
});

// Preload heavy images or gifs that are used in other pages
Helpers.preloadImages([
  "img/projects/bumblebee-icon.gif",
  "img/projects/dreamland-icon.gif",
  "img/projects/dreamland-icon2.gif",
  "img/projects/frozen2-icon.gif",
  "img/projects/hololens1.gif",
  "img/projects/hololens2.gif",
  "img/projects/hololens3.gif",
  "img/projects/hololens4.gif",
  "img/projects/legobatman-icon.gif",
  "img/projects/luca-icon.gif",
  "img/projects/neonslaught-icon.gif",
  "img/projects/spidey-icon.gif",
  "img/projects/xr-icon.gif"
]);

